export type AuthToken = string;
export type DeleteModal = {
  isLoading: boolean;
  isVisible: boolean;
  modalData?: DeleteModalData;
};
export type IsSidebarExpanded = boolean;

export type InstanceType = {
  label: string;
  value: string;
};

export interface State {
  activeDeploymentId?: string;
  authToken?: AuthToken;
  deleteModal: DeleteModal;
  isSidebarExpanded: IsSidebarExpanded;
  sfToken?: AuthToken;
  activeInstance?: InstanceType;
  lastSavedChanges?: Date;
}

const STORAGE_KEY = '@rollio/cms.store';

const INITIAL_STATE = {
  activeDeploymentId: undefined,
  authToken: undefined,
  deleteModal: { isLoading: false, isVisible: false },
  isSidebarExpanded: true,
  sfToken: undefined,
  activeInstance: undefined,
  lastSavedChanges: undefined,
};

const recoverInitialState = () => {
  const storage = window.localStorage.getItem(STORAGE_KEY);

  if (storage) {
    try {
      return JSON.parse(storage);
    } catch {
      return {};
    }
  }

  return {};
};

export const storeStateLocally = (state: State) =>
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));

export const initialState = {
  ...INITIAL_STATE,
  ...recoverInitialState(),
};
